<div class="loc-picker">
    <div class="loc-picker__toolbar">
        <div class="loc-picker__search">
            <mat-icon class="loc-picker__search-icon">search</mat-icon>
            <input
                    type="text"
                    [(ngModel)]="search"
                    (keyup)="changeSearch()"
                    [placeholder]="searchPlaceholder"
                    aria-label="Search organizations, locations and users"/>
            <button
                    type="button"
                    class="loc-picker__icon-btn"
                    *ngIf="search"
                    (click)="clearSearch()"
                    aria-label="Clear search">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="loc-picker__selection">
            <span class="loc-picker__count" [class.is-active]="selectedLocations.length > 0">
                <mat-icon>check_circle</mat-icon>
                {{ selectedLocations.length }} selected
            </span>
            <button
                    type="button"
                    class="loc-picker__link"
                    *ngIf="selectedLocations.length > 0"
                    (click)="clearSelection()">
                Clear
            </button>
        </div>
    </div>

    <div class="loc-picker__body">
        <ng-container *ngIf="!isLoading">
            <app-organization-with-locations-form
                    *ngFor="let organization of organizations; trackBy: trackByOrganizationId"
                    (_locationPressed)="pressLocation($event)"
                    [organization]="organization"
                    [showCheckboxes]="showCheckboxes"
                    [disabledLocationIds]="disabledLocationIds"
                    [requireActive]="requireActive"
                    [searchTerm]="activeSearch">
            </app-organization-with-locations-form>

            <div class="loc-picker__empty" *ngIf="organizations.length === 0">
                <mat-icon>travel_explore</mat-icon>
                <p class="loc-picker__empty-title">No locations found</p>
                <p class="loc-picker__empty-hint" *ngIf="activeSearch">
                    Nothing matches "{{ activeSearch }}". Try another organization, location or username.
                </p>
            </div>
        </ng-container>

        <div class="loc-picker__loading" *ngIf="isLoading">
            <mat-spinner diameter="32"></mat-spinner>
            <p>Loading locations…</p>
        </div>
    </div>

    <div class="loc-picker__footer">
        <mat-paginator
                class="loc-picker__paginator"
                [pageSize]="itemsPerPage"
                [pageIndex]="page"
                [pageSizeOptions]="pageSizeOptions"
                [length]="totalCount"
                (page)="changePage($event)"
        ></mat-paginator>

        <div class="loc-picker__actions" *ngIf="showActions">
            <button mat-stroked-button type="button" (click)="onCancel()">Cancel</button>
            <button
                    mat-flat-button
                    color="primary"
                    type="button"
                    [disabled]="selectedLocations.length === 0"
                    (click)="onSubmit()">
                {{ submitLabel }}<ng-container *ngIf="selectedLocations.length > 0">&nbsp;({{ selectedLocations.length }})</ng-container>
            </button>
        </div>
    </div>
</div>
